module.exports = __webpack_public_path__ + "static/media/CoffeeCalc.f06928d6.png";